import React, { useState, useEffect } from 'react';
import Axios from "axios";
import ConsultantLayout from '../commonlayouts/consultantlayout';
import { Link, useNavigate } from 'react-router-dom';
import { GenerateContent, SendMailToLeads } from '../apiconstants/constants';
import WYSIWYGEditor from "../helpers/WYSIWYGEditor";
import { useForm, Controller } from "react-hook-form";
import Swal from "sweetalert2";
import LoadingSpinner from "../helpers/loadingspinner";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { templates } from '../helpers/leadsmailtemplates';

const SelectedLeadsCustomMail = () => {
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const storedCandidates = JSON.parse(localStorage.getItem('selectedLeads') || '[]');
  const [isLoading, setIsLoading] = useState(false);
  const { register, reset, handleSubmit, control, formState: { errors, isSubmitting } } = useForm();
  const navigate = useNavigate();
  const [isDisabled, setIsDisabled] = useState(false);
  const clientData = JSON.parse(localStorage.getItem("clientData"));
 const fileInputRef = React.useRef();
const [attachments, setAttachments] = useState([]);
   const [selectedCCEmail, setSelectedCCEmail] = useState("sales@knackhook.com");
const [previewHtml, setPreviewHtml] = useState("");
const [showPreview, setShowPreview] = useState(false);
    const email = localStorage.getItem("email")
      const guid = localStorage.getItem("guid")
      const token = localStorage.getItem('jwtToken');
        const mobileNumber = localStorage.getItem("mobileNumber");
     const firstName = localStorage.getItem("firstName") || "";
const lastName = localStorage.getItem("lastName") || "";
const [selectedCategory, setSelectedCategory] = useState("");
// Concatenate with a space in between
const senderName = `${firstName} ${lastName}`.trim();

const handleFileChange = (e) => {
  const newFiles = Array.from(e.target.files);
  setAttachments(prev => [...prev, ...newFiles]);
};

const removeFile = (index) => {
  setAttachments(prev => prev.filter((_, i) => i !== index));
};


  useEffect(() => {
    if (storedCandidates) {
      setSelectedCandidates(storedCandidates);
    }
  }, []);

  const onSubmit = async (data, e) => {
    console.log(data);
    e.preventDefault();
    reset();
    setIsLoading(true);
    sendSelectedItemsToApi(data);
  }

const generatePreviewTemplate = (formData) => {
  const recipientsTable = selectedCandidates
    .map(c => `<tr>
      <td style="padding:4px; border:1px solid #ccc;">${c.fullName}</td>
      <td style="padding:4px; border:1px solid #ccc;">${c.email}</td>
    </tr>`)
    .join("");

  return `
    <div style="font-family: Arial, sans-serif; line-height: 1.6;">
          <p>Dear ${selectedCandidates[0]?.fullName || "Recipient"},</p>
      <div>${formData.content || ""}</div>
      <p style="margin-top:20px;">Best regards,<br/>
  <strong>${senderName || "KnackHook Sales Team " },</strong><br/>
      ✉️ ${email || "sales@knackhook.com"},<br/>
      📞 ${mobileNumber || ""}.</p>
     
    </div>
  `;
};
const getNextStage = (currentStage) => {
  if (!currentStage || currentStage.toLowerCase() === "null") return "Initial";

  switch (currentStage) {
    case "Initial":
      return "FollowUp-1";
    case "FollowUp-1":
      return "FollowUp-2";
    case "FollowUp-2":
      return "FollowUp-3";
    case "FollowUp-3":
      return "Closed"; // cap it here
    case "Engaged":
      return "Engaged"; // stays the same, no follow-up needed
    default:
      return "Initial"; // fallback
  }
};


useEffect(() => {
  reset({ subject: "", content: "" });
}, []);

  
  const sendSelectedItemsToApi = async (data) => {
  setIsLoading(true);

  // Prepare the leads JSON string
  const leads = selectedCandidates.map(candidate => ({
    leadId:candidate.id,
    name: candidate.fullName,
    email: candidate.email
  }));

  const formData = new FormData();
  formData.append("CompanyName", clientData?.companyName || "");
  formData.append("LogoUrl", clientData?.logoURL || "");
  formData.append("Subject", data.subject);
  formData.append("Content", data.content);
  formData.append("LeadsJson", JSON.stringify(leads)); // Use LeadsJson instead of leads
  formData.append("FromMail", email || "");
  formData.append("CCmail", selectedCCEmail||"sales@knackhook.com");
  formData.append("Phonenumber", mobileNumber || "");
  formData.append("UserGuid", guid);
  formData.append("Guid", guid);
formData.append("senderName", senderName);
  attachments.forEach(file => {
    formData.append("attachments", file); // Keep key name as 'attachments'
  });

  try {
    const result = await Axios.post(SendMailToLeads.APIURL, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Authorization": `Bearer ${token}`,
      }
    });

    setIsLoading(false);

    if (result.data === 'Emails sent successfully to all leads.') {
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Sent Successfully',
        showConfirmButton: false,
        timer: 5000
      });
       localStorage.removeItem("aimail");
      navigate("/Employer/ListOfLeads");
    } else {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Add correct Details',
        showConfirmButton: false,
        timer: 5000
      });
    }
  } catch (error) {
    console.error("Error", error);
    setIsLoading(false);
  }
};

const capitalize = (str) =>
  str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "";

// const buildTemplate = async (category, stage, lead) => {
//   let { subject, body } = templates[category][stage] || { subject: "", body: "" };

//   // Candidate first name (capitalized)
//   const firstName = lead.fullName
//     ? capitalize(lead.fullName.trim().split(" ")[0])
//     : "there";

//   // Sender name (only first name, capitalized)
//   const senderName = capitalize(localStorage.getItem("firstName") || "");

//   // Replace placeholders in static template
//   subject = subject.replace("[First Name]", firstName);
//   body = body.replace(/\[First Name\]/g, firstName);
//   body = body.replace(/\[SenderName\]/g, senderName);
//   body = body.replace(/\[Company Name\]/g, lead.companyName || "your company");

//   // --- Call Gemini for AI First Para ---
//   let aiFirstPara = "";
//   try {
//     const response = await Axios.post(
//       GenerateContent.APIURL,
//       {
//         prompt: `
// You are an email generation assistant.
// Generate ONLY the first paragraph (2–3 sentences, HTML allowed) for an outreach email.

// Lead details:
// - First Name: ${lead.fullName || "there"}
// - Company: ${lead.companyName || "the company"}
// - Domain/Description: ${lead.domain || "working on GTM and AI"}

// ⚠️ IMPORTANT:
// - Do not include greeting or closing — only the first paragraph content.
// Return valid JSON only, in this format:
// {
//   "firstPara": "Your generated paragraph here"
// }
//         `
//       },
//       {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );

//     const raw = response.data?.response?.candidates?.[0]?.content?.parts?.[0]?.text || "";
//     const jsonMatch = raw.match(/\{[\s\S]*\}/);
//     if (jsonMatch) {
//       const parsed = JSON.parse(jsonMatch[0]);
//       aiFirstPara = parsed.firstPara || "";
//     }
//   } catch (err) {
//     console.error("Error fetching AI para:", err);
//   }

//   // Replace the static first paragraph with AI content
//   if (aiFirstPara) {
//     body = body.replace(/^(.*?)(<br\/><br\/>|$)/s, aiFirstPara + "<br/><br/>");
//   }

//   return { subject, body };
// };

const buildTemplate = async (category, stage, lead) => {
  let { subject, body } = templates[category][stage] || { subject: "", body: "" };

  // Candidate first name (capitalized)
  const firstName = lead.fullName
    ? capitalize(lead.fullName.trim().split(" ")[0])
    : "there";

  // Sender name (only first name, capitalized)
  const senderName = capitalize(localStorage.getItem("firstName") || "");

  // Replace static placeholders
  subject = subject.replace("[First Name]", firstName);
  body = body.replace(/\[First Name\]/g, firstName);
  body = body.replace(/\[SenderName\]/g, senderName);
  body = body.replace(/\[Company Name\]/g, lead.companyName || "your company");
  // Use companyName or "your company" if null/empty
  const companyName = lead.companyName?.trim() || "your company";
  const domain = lead.domain || "technology";
  // --- Call Gemini for AI First Para (based on domain + actual company name) ---
  let aiFirstPara = "";
  try {
    const response = await Axios.post(
      GenerateContent.APIURL,
      {
        prompt: `Write a professional and appreciative first paragraph (2–3 sentences) for a business email that compliments the company "${companyName}" for its expertise and leadership in "${domain}". 
Highlight what makes their work remarkable, innovative, or impactful in this field. Make it sound warm, genuine, and personal. 
Do NOT use placeholders like [Company Name]. Return JSON only:
{
  "firstPara": "..."
}
`
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const raw = response.data?.response?.candidates?.[0]?.content?.parts?.[0]?.text || "";
    const jsonMatch = raw.match(/\{[\s\S]*\}/);
    if (jsonMatch) {
      const parsed = JSON.parse(jsonMatch[0]);
      aiFirstPara = parsed.firstPara || "";
    }
  } catch (err) {
    console.error("Error fetching AI para:", err);
  }

  // Replace AI placeholder in body
  body = body.replace("{{AI_CONTENT}}", aiFirstPara || "");

  return { subject, body };
};



  const handleCategoryChange = async (category) => {
    setSelectedCategory(category); 
    if (!category || selectedCandidates.length === 0) return;
    const lead = selectedCandidates[0];
    const nextStage = getNextStage(lead.currentStage);
    setIsLoading(true);
    const { subject, body } = await buildTemplate(category, nextStage, lead);
    reset({ subject, content: body });
    setIsLoading(false);
  };

  return (
    <ConsultantLayout>
      {isLoading ? <center><LoadingSpinner /></center> :
        <div className='container-fluid mt-3'>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Link to="/Employer/ListOfLeads">
              <i className="fa fa-arrow-left" onClick={() => {
    localStorage.removeItem("aimail");
    navigate("/Employer/ListOfLeads");
  }} style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px', marginTop: 8 }} aria-hidden="true"></i>
            </Link>
            <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: 8 }}>Selected Leads</h2>
          </div>
          <table className="table">
            <thead>
              <tr>
                <th>Full Name</th>
                <th>Email</th>
              </tr>
            </thead>
            <tbody>
              {selectedCandidates.map(item => (
                <tr key={item.id}>
                  <td>{item.fullName}</td>
                  <td>{item.email}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <form onSubmit={handleSubmit(onSubmit)} id="loginform">
           
             <div className="mt-3" >
              <label style={{ color: "#00a7ac" }}>Select Email Category</label>
              <select className="form-control" style={{height:50}}  value={selectedCategory}   onChange={(e) => handleCategoryChange(e.target.value)} defaultValue="">
                <option value="" disabled>Select category</option>
                <option value="Software Development">Software Development</option>
                <option value="Personal and Business Branding">Personal and Business Branding</option>
                <option value="AI Development">AI Development</option>
                <option value="Staffing Collaboration">Staffing Collaboration</option>
              </select>
            </div>
             <div>
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Subject</Tooltip>)}>
                <input type="text" title='' placeholder='Subject' {...register("subject", { required: "Subject Required" })} id="subject" name="subject"
                  disabled={isDisabled} className={`form-control basic-form mt-3 ${errors.subject ? 'is-invalid' : ''}`}
                />
              </OverlayTrigger>
              <div className="invalid-feedback"> {errors.subject?.message}</div>
            </div>
            <input
  type="text"
  {...register("emailCC")}
  className="form-control basic-form mt-3"
  placeholder="CC Email"
  value={selectedCCEmail}
  onChange={(e) => setSelectedCCEmail(e.target.value)}
/>
            <div>
              <label style={{ color: "#00a7ac", marginTop: 10 }}>Content</label>
              <Controller
                control={control}
                name="content"
                rules={{
                  required: { value: true, message: "Content Required" },
                }}
                render={({ field: { onChange, onBlur, value, ref } }) => (
                  <div>
                    <WYSIWYGEditor
                      onChange={onChange}
                      onBlur={onBlur}
                      value={value}
                      ref={ref}
                      inputExtraProps={{
                        required: true,
                      }}
                    />
                    {errors.content && (
                      <p style={{ marginTop: '0.25em', fontSize: '80%', color: '#dc3545' }}>
                        {errors.content.message}
                      </p>
                    )}
                  </div>
                )}
              />
            </div>
           <div className="mt-3">
  {/* <label style={{ color: "#00a7ac" }}>Attachments</label> */}
  <div
    style={{
      // border: "1px dashed #ccc",
      padding: 10,
      borderRadius: 6,
      cursor: "pointer",
      display: "inline-block",
       color: "#00a7ac"  
    }}
    onClick={() => fileInputRef.current.click()}
  >
    <i className="fas fa-paperclip" style={{ marginRight: 6,color: "#00a7ac"  }}></i> Attach files
  </div>
  <input
    type="file"
    ref={fileInputRef}
    style={{ display: "none" }}
    multiple
    onChange={handleFileChange}
  />
</div>
{attachments.length > 0 && (
  <div className="mt-2">
    {attachments.map((file, index) => (
      <div
        key={index}
        style={{
          background: "#f1f1f1",
          padding: "6px 10px",
          borderRadius: 4,
          marginBottom: 4,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between"
        }}
      >
        <span>
          <i className="fas fa-file" style={{ marginRight: 8 }}></i>
          {file.name} ({Math.round(file.size / 1024)} KB)
        </span>
        <button
          type="button"
          className="btn btn-sm btn-link text-danger"
          onClick={() => removeFile(index)}
        >
          <i className="fas fa-times"></i>
        </button>
      </div>
    ))}
  </div>
)}


      <div className="row mb-4 mt-3"> 
  <div className="col-12 d-flex justify-content-end gap-2 mb-3 mt-5">

    {/* Preview Button */}
    <button
      type="button"
      className="btn btn-primary"
      onClick={handleSubmit((formData) => {
        const html = generatePreviewTemplate(formData);
        setPreviewHtml(html);
        setShowPreview(prev => !prev); // toggle
      })}
    >
      {showPreview ? "Hide Preview" : "Preview Email"}
    </button>

    {/* Send Email Button */}
    <button
      id="svbutton"
      disabled={isSubmitting || isDisabled}
      className="btn btn-primary"
    >
      Send Email
    </button>

    {/* Cancel Button */}
    <Link to="/Employer/ListOFLeads">
      <button className="btn btn-primary">
        Cancel
      </button>
    </Link>

  </div>
</div>


          </form>
         
          {showPreview && (
  <div className="card mt-4 p-3" style={{ border: "1px solid #ccc", fontSize: 14 }}>
    <h4>Email Preview</h4>
    <div dangerouslySetInnerHTML={{ __html: previewHtml }} />
  </div>

)}

        </div>
      }
    </ConsultantLayout>
  );
}

export default SelectedLeadsCustomMail;
